(function () {

    'use strict';

    angular.module('etEcWrapper', [])
        .provider('etEcWrapper', EtEcWrapperProvider);

    EtEcWrapperProvider.$inject = [
        '$windowProvider'
    ];
    function EtEcWrapperProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.et_eC_Wrapper || {};
            }
        };
    }
})();
